import {
  faPlusCircle,
  faArrowsUpDownLeftRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Spinner, Table } from "reactstrap";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Container from "../../../components/Container";
import AppLayout from "../../../components/layouts/AppLayout";
import API from "../../../utils/API";
import Create from "./Create";
import Delete from "./Delete";
import Edit from "./Edit";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const Index = () => {
  const [studyLevels, setStudyLevels] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    let tempData = Array.from(studyLevels);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    const newOrder = tempData.map((item) => item.id);
    API.post("/api/studylevel/order", {
      order: newOrder,
    });
    setStudyLevels(tempData);
  };

  const fetchStudyLevels = async () => {
    try {
      const data = (await API.get("/api/study-levels")).data.data;
      setStudyLevels(data);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudyLevels();
  }, [refresh]);

  return (
    <AppLayout>
      <Breadcrumbs
        title="Study Levels"
        links={[
          {
            title: "Dashboard",
            link: null,
          },
          {
            title: "Study Levels",
            link: null,
          },
        ]}
      />
      <Container>
        <Card className="border-0 shadow mt-5" style={{ minHeight: "70vh" }}>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h1 className="mb-0">All Study Levels</h1>
              <Create
                studyLevel={studyLevels}
                fetchStudyLevels={fetchStudyLevels}
              />
            </div>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Table hover responsive>
                <thead>
                  <tr className="bg-shade-blue">
                    <th>#</th>
                    <th></th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Program</th>
                    <th>Created_at</th>
                    <th>Updated_at</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <Droppable droppableId="droppable-1" className="w-100">
                  {(provider) => (
                    <tbody
                      className="text-capitalize"
                      ref={provider.innerRef}
                      {...provider.droppableProps}>
                      {studyLevels.length > 0 ? (
                        studyLevels.map((studyLevel, index) => (
                          <Draggable
                            key={studyLevel.thumbnail}
                            draggableId={studyLevel.thumbnail}
                            index={index}>
                            {(provider) => (
                              <tr
                                className="drag-box"
                                {...provider.draggableProps}
                                {...provider.dragHandleProps}
                                ref={provider.innerRef}
                                key={`studyLevel-${studyLevel.id}`}>
                                <th
                                  style={{
                                    verticalAlign: "middle",
                                  }}
                                  scope="row">
                                  {index + 1}
                                </th>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                  }}
                                  {...provider.dragHandleProps}>
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={
                                      faArrowsUpDownLeftRight
                                    }></FontAwesomeIcon>{" "}
                                </td>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                  }}>
                                  <img
                                    style={{ width: "90px" }}
                                    src={
                                      `${process.env.REACT_APP_API_URL}` +
                                      studyLevel.thumbnail
                                    }
                                    alt="Image"
                                  />
                                </td>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                  }}>
                                  {studyLevel.name}
                                </td>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                  }}>
                                  {studyLevel.relationships.programs.length}
                                </td>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                  }}>
                                  {moment(studyLevel.created_at).format(
                                    "DD/MM/YY"
                                  )}
                                </td>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                  }}>
                                  {moment(studyLevel.updated_at).format(
                                    "DD/MM/YY"
                                  )}
                                </td>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                  }}>
                                  <Edit
                                    studyLevel={studyLevel}
                                    fetchStudyLevels={fetchStudyLevels}
                                  />

                                  <Delete
                                    studyLevel={studyLevel}
                                    refresh={refresh}
                                    setRefresh={setRefresh}
                                  />
                                </td>
                              </tr>
                            )}
                          </Draggable>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={10} className="text-center">
                            {loading ? (
                              <Spinner
                                style={{ width: "30px", height: "30px" }}
                              />
                            ) : (
                              "No study Levels Exists"
                            )}
                          </td>
                        </tr>
                      )}
                      {provider.placeholder}
                    </tbody>
                  )}
                </Droppable>
              </Table>
            </DragDropContext>
          </CardBody>
        </Card>
      </Container>
    </AppLayout>
  );
};

export default Index;
